import dayjs from "dayjs";
import { environment } from "src/environment";
import type { AxiosResponse } from "axios";

const doesSupportsGroupCollapsed = String(console.groupCollapsed).includes(
  "code",
);

export function responseLogger(response: AxiosResponse) {
  const lines = [];
  const {
    url = "Unknown URL",
    method = "Unknown method",
    baseURL = "Unknown base URL",
    params = {},
  } = response.config;

  const queryParams =
    (Object.keys(params).length ? "?" : "") +
    Object.entries(params)
      .map(([key, value]) => (value === undefined ? "" : key + "=" + value))
      .join("&");
  lines.push(
    `${method.toUpperCase()} ${
      url.replace(baseURL, "") + queryParams
    } | RESPONSE`,
  );

  const maxLines = 320;
  const maxLineLength = 180;
  const { data } = response;
  if (data) {
    const dataString = JSON.stringify(data ?? "ɴᴏ ᴘᴀʏʟᴏᴀᴅ", null, 2)
      .split("\n")
      .slice(0, maxLines)
      .map((line) =>
        line.length > maxLineLength
          ? line.slice(0, maxLineLength - 10) +
            "…" +
            line.slice(maxLineLength - 10, 9)
          : line,
      )
      .join("\n");
    lines.push(`ᴘᴀʏʟᴏᴀᴅ\n${dataString}`);
  }

  const pretty = lines
    .join("\n")
    .split("\n")
    .map((l) => "< " + l);
  pretty.push("");

  const requestedAt = (response.config as any)["_requested_at"];
  const diff = dayjs().diff(requestedAt, "ms");

  const urlReplaced = url.replace(environment.TOS_API_URL, "/");

  const groupTitle = `${method.toUpperCase()} ${
    urlReplaced + queryParams
  } ${diff}ms | RESPONSE`;

  if (doesSupportsGroupCollapsed) {
    (console as any).groupCollapsed("%c" + groupTitle, "color: #00b300");
    console.log(pretty.join("\n"));
    console.groupEnd();
  } else {
    // Make messages appear green in console
    console.log("\x1b[32m%s\x1b[0m", groupTitle);

    // Unncomment if you want to log response payload in console
    // pretty.splice(0, 2, groupTitle);
    // console.log(
    //   pretty
    //     .map((line, index) => (index === 0 ? line : `      ${line}`))
    //     .join("\n")
    // );
  }

  return response;
}
